import React from "react";
import "./HeroEstore.css";
import { useNavigate } from "react-router-dom";
export default function Hero() {
  const navigate = useNavigate();
  return (
    <section className="hero1" id="hero1">
      {/* ✅ Overlay for better contrast */}
      <div className="hero1-overlay1"></div>
      <div className="hero1-content1">
        <h1>Pakistan’s No.1 Locally Made Paint Brand</h1>
        <button className="cta1-btn1" onClick={() => navigate("/e-store")}>
          BUY YOUR FAVOURITE PAINTS NOW!
        </button>
      </div>
    </section>
  );
}
